export default __webpack_public_path__ + "static/media/403-error-forbidden-pana.61ac6e25.svg";